<div class="header">
  <div class="object-name">
    {{ attributes.name }}
    @if (attributes.id) {
      <span class="secondary-info">
        / {{ attributes.id }}</span
        >
      }
    </div>
    <div class="sub-header">
      {{ attributes.frequency
      }}@if (attributes.dmeChannel) {
      <span>
        (Channel {{ attributes.dmeChannel }})</span
        >
      }
    </div>
  </div>
  <div class="info-container">
    @if (attributes.coordinates) {
      <div class="info">
        <p class="field-title">Location</p>
        {{ attributes.coordinates }}
      </div>
    }
    @if (attributes.type) {
      <div class="info">
        <p class="field-title">Type</p>
        {{ attributes.type }}
      </div>
    }
    @if (attributes.type) {
      <div class="info">
        <p class="field-title">Declination</p>
        {{ attributes.stationDeclinationDegrees }}
      </div>
    }
    @if (attributes.serviceVolume) {
      <div class="info">
        <p class="field-title">Service Volume</p>
        {{ attributes.serviceVolume }}
      </div>
    }
    @if (attributes.morseCode) {
      <div class="info">
        <p class="field-title">Morse Code</p>
        {{ attributes.morseCode }}
      </div>
    }
    @if (attributes.minCrossingAlt) {
      <div class="info">
        <p class="field-title">Minimum Crossing Altitude</p>
        {{ attributes.minCrossingAlt }}
      </div>
    }
    @if (attributes.isOnAirway) {
      <div class="info">
        <p class="field-title">Additional Info</p>
        {{ attributes.isOnAirway }}
      </div>
    }
  </div>
